import { render, staticRenderFns } from "./LocationsEditDialog.vue?vue&type=template&id=8b9b9960"
import script from "./LocationsEditDialog.js?vue&type=script&lang=js&external"
export * from "./LocationsEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports